export default __webpack_public_path__ + "static/personaje2x2-e61c58eed48f92090857ba1cda98df0b.png";